module.exports = __webpack_public_path__ + "fonts/medium.34fd6aca.woff";